import type { PublicConfig } from "./types";

const STORAGE_KEY = "sk:public-config";

/**
 * Public client configuration (no secrets). Remembered locally so the installed app can boot
 * Firebase Auth offline; the live server value always wins when reachable.
 */
export async function loadPublicConfig(): Promise<PublicConfig> {
  try {
    const res = await fetch("/api/config", { cache: "no-store", headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error(`config ${res.status}`);
    const config = (await res.json()) as PublicConfig;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
    } catch {
      // storage unavailable (private mode) — fine, just no offline boot
    }
    return config;
  } catch (error) {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) return JSON.parse(saved) as PublicConfig;
    } catch {
      // ignore
    }
    throw error;
  }
}
